<template>
  <div>
    <el-input size="medium"
              :style="{'width': width + 'px'}"
              :placeholder="placeholder" @clear="search"
              @keyup.enter.native="search" clearable v-model="keyword" class="input-with-select">
      <el-button slot="append" type="primary" size="medium" icon="el-icon-search" @click="search"/>
    </el-input>
  </div>


</template>

<script>


export default {
  name: "SSearch",
  props: {
    placeholder: {
      type: String,
      default: '请输入内容',
    },
    width: {
      type: Number,
      default: 250
    }
  },
  data() {
    return {
      keyword: '',
    }
  },
  created() {

  },
  methods: {
    search() {
      this.$emit('search', this.keyword)
    }
  },
}
</script>
<style scoped>
/deep/ .el-input-group__append {
  background-color: #0061eb;
  border-color: #0061eb;
  transition: all .3s;
}
/deep/ .el-input-group__append:active {
  background-color: #004ab3;
  border-color: #004ab3;
}
</style>

